export default __webpack_public_path__ + "static/media/partner5.42ba0a5a.png";